import { useCallback } from 'react';

import * as SplashScreen from 'expo-splash-screen';
import { Platform, View } from 'react-native';

import { IBaseProps } from '@rbi-ctg/frontend';

class Deferred {
  public reject!: (reason?: any) => void;
  public resolve!: (value?: any) => void;
  public promise = new Promise((resolve, reject) => {
    this.reject = reject;
    this.resolve = resolve;
  });
}

// there is a bug on iOS if you display a modal before splash screen is gone you can't get off of the splash screen
// expose splash screen status to Modals across the app to avoid
export const splashScreenHiddenDeferred = new Deferred();

export const HideSplashScreen: React.FC = ({ children }: IBaseProps) => {
  return (
    <View
      onLayout={useCallback(() => {
        // web doesn't have a splash screen so no need to delay (and don't rely on them keeping SplashScreen code working on web)
        Platform.OS === 'web'
          ? splashScreenHiddenDeferred.resolve()
          : SplashScreen.hideAsync().finally(() => splashScreenHiddenDeferred.resolve());
      }, [])}
    >
      {children}
    </View>
  );
};
